export class MachineFormValues {

    // ContractorSchema {
    //     contractorId: number
    //     contractor: name
    //     schemaOptions: SelectOption[]
    //     schema: SelectOption[]
    // }

    _licensePlate; // string
    _state; // boolean
    _brand; // string
    _model; // string
    _description; // string
    _contractorId; // number
    _contractorSchemas; // ContractorSchema

    constructor(
        licensePlate,
        state,
        brand,
        model,
        description,
        contractorId,
        contractorSchemas,
    ) {
        this._licensePlate = licensePlate;
        this._state = state;
        this._brand = brand;
        this._model = model;
        this._description = description;
        this._contractorId = contractorId;
        this._contractorSchemas = contractorSchemas;
    }

    static null() {
        return new this(
            '',
            false,
            '',
            '',
            '',
            -1,
            [],
        );
    }

    static fromCurrentUser(user) {
        return new this(
            '',
            false,
            '',
            '',
            '',
            user.contractorId(),
            [],
        );
    }

    static fromMachine(machine) {
        const contractorSchemas = machine
            .documentation()
            .schemas()
            .map((association) => {
                const contractor = association.contractor();
                const documentSchema = association.documentSchema();

                return {
                    contractorId: contractor.id(),
                    contractor: contractor.description(),
                    schemaOptions: [], // completados en ResourceContractorSchemas
                    schema: [{
                        label: documentSchema.description(),
                        value: documentSchema.id(),
                        disabled: false,
                        item: documentSchema,
                    }],
                };
            });

        return new this(
            machine.licensePlate(),
            machine.isActive(),
            machine.brand(),
            machine.model(),
            machine.description(),
            machine.contractorId(),
            contractorSchemas,
        );
    }

    initialValues() {
        return {
            licensePlate: this._licensePlate,
            state: this._state,
            brand: this._brand,
            model: this._model,
            description: this._description,
            contractorId: this._contractorId,
            contractorSchemas: this._contractorSchemas,
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/machine/form/MachineFormValues.js